module.exports = __webpack_public_path__ + "img/SiDao.0a593048.png";